module.exports = __webpack_public_path__ + "media/images/corner-tab-80cba1802c6b41fce9c914bd17fc5e76.png";